import {
  SET_CURRENT_QUARTER,
  SET_SCHOOL_YEAR,
  SET_SCHOOL_YEAR_ID,
  INITIALIZE_QUARTER,
  SET_QUARTER_LOADING,
  SET_QUARTER_ERROR
} from '../actions/QuarterA';

import { getCurrentQuarter, getCurrentSchoolYear } from '../../utils/quarterUtils';

// Initial state
const initialState = {
  currentQuarter: getCurrentQuarter(),
  schoolYear: getCurrentSchoolYear(),
  schoolYearId: null,
  loading: false,
  error: null,
  initialized: false
};

// Reducer
const QuarterR = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_QUARTER:
      return {
        ...state,
        currentQuarter: action.payload,
        error: null
      };

    case SET_SCHOOL_YEAR:
      return {
        ...state,
        schoolYear: action.payload,
        error: null
      };

    case SET_SCHOOL_YEAR_ID:
      return {
        ...state,
        schoolYearId: action.payload,
        error: null
      };

    case INITIALIZE_QUARTER:
      return {
        ...state,
        currentQuarter: action.payload.quarter,
        schoolYear: action.payload.schoolYear,
        initialized: true,
        error: null
      };

    case SET_QUARTER_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case SET_QUARTER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    default:
      return state;
  }
};

export default QuarterR;